import { Connection1cFindDto, type Connection1cFindInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';

import * as yup from 'yup';

/** DTO signature */
export interface CostItemFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Creation date and type */
  created: Date;
  /** Last update date and type */
  updated: Date;
  /** Soft deletion date and type */
  deleted?: Date;
  /** Cost item 1C ERP reference ID */
  ref: string;
  /** Cost item 1C ERP database */
  connection: Connection1cFindInterface;
  /** Cost item display name */
  name: string;
}

/** DTO schema */
export const CostItemFindDto = SerdeDtoClass.create<CostItemFindInterface>(CatalogDtosKeysEnum.COST_ITEM_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    sortable: true,
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удален',
    serializer: yup.date(),
  },
  ref: {
    label: 'Идентификатор в 1С',
    serializer: yup.string(),
  },
  connection: {
    sortable: true,
    label: 'База 1С',
    nested: Connection1cFindDto,
    serializer: (_, nested) => nested,
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
});
